export default __webpack_public_path__ + "static/media/mercy-medicalemergency.ec7a8ffa.mp3";